var axios = require('axios');

export const fetchApi = async (d, url, setEusstg, setWeustg, setEjpprd, setEusprd, setWeuprd, setWusprd, setEusstgCount, setWeustgCount, setEusprdCount, setWeuprdCount, setEjpprdCount, setWusprdCount) => {

// https://supportmonitor.au10tixservicesdev.com
    for (let i = 0; i < d.length; i++) {
        try {
            const response = await axios({
                method: 'post',
                url: `https://mss.au10tixservicesdev.com/${url}`,
                headers: {
                    'Content-Type': 'application/json'
                },
                data: JSON.stringify({
                    "enviroment": d[i].env,
                    "region": d[i].region
                }),
                timeout: 40000
            })
            const res = response.data
            if (String(res.StatusCode).startsWith("2") && res.region === "eus" && res.enviorment === "staging") {
                setEusstg("#07eb57")
                setEusstgCount(0)
            } else if (String(res.StatusCode).startsWith("2") && res.region === 'weu' && res.enviorment === 'staging') {
                setWeustg("#07eb57")
                setWeustgCount(0)
            } else if (String(res.StatusCode).startsWith("2") && res.region === "wus" && res.enviorment === "") {
                setWusprd("#07eb57")
                setWusprdCount(0)
            } else if (String(res.StatusCode).startsWith("2") && res.region === 'eus' && res.enviorment === '') {
                setEusprd("#07eb57")
                setEusprdCount(0)
            } else if (String(res.StatusCode).startsWith("2") && res.region === 'weu' && res.enviorment === '') {
                setWeuprd("#07eb57")
                setWeuprdCount(0)
            } else if (String(res.StatusCode).startsWith("2") && res.region === 'ejp' && res.enviorment === '') {
                setEjpprd("#07eb57")
                setEjpprdCount(0)
            }
            else {
                if (d[i].region === 'eus' && d[i].env === 'staging') {
                    setEusstg("red")
                    setEusstgCount(count => count + 1)
                    console.log("failed on eus stg")
                } else if (d[i].region === 'weu' && d[i].env === 'staging') {
                    setWeustg("red")
                    setWeustgCount(count => count + 1)
                    console.log("failed on weu stg")
                }
                else if (d[i].region === 'wus' && d[i].env === 'production') {
                    setWusprd("red")
                    setWusprdCount(count => count + 1)
                    console.log("failed on wus prd")
                } else if (d[i].region === 'eus' && d[i].env === 'production') {
                    setEusprd("red")
                    setEusprdCount(count => count + 1)
                    console.log("failed on eus prd")
                } else if (d[i].region === 'weu' && d[i].env === 'production') {
                    setWeuprd("red")
                    setWeuprdCount(count => count + 1)
                    console.log("failed on weu prd")
                } else if (d[i].region === 'ejp' && d[i].env === 'production') {
                    setEjpprd("red")
                    setEjpprdCount(count => count + 1)
                    console.log("failed on ejp prd")
                }
            }
        } catch (error) {
            if (d[i].region === 'eus' && d[i].env === 'staging') {
                setEusstg("red")
                setEusstgCount(count => count + 1)
                console.log("failed on eus stg")
            } else if (d[i].region === 'weu' && d[i].env === 'staging') {
                setWeustg("red")
                setWeustgCount(count => count + 1)
                console.log("failed on weu stg")
            }
            else if (d[i].region === 'wus' && d[i].env === 'production') {
                setWusprd("red")
                setWusprdCount(count => count + 1)
                console.log("failed on wus prd")
            } else if (d[i].region === 'eus' && d[i].env === 'production') {
                setEusprd("red")
                setEusprdCount(count => count + 1)
                console.log("failed on eus prd")
            } else if (d[i].region === 'weu' && d[i].env === 'production') {
                setWeuprd("red")
                setWeuprdCount(count => count + 1)
                console.log("failed on weu prd")
            } else if (d[i].region === 'ejp' && d[i].env === 'production') {
                setEjpprd("red")
                setEjpprdCount(count => count + 1)
                console.log("failed on ejp prd")
            }
        }
    }
    setTimeout(() => {
        setEusstg("skyblue")
        setWeustg("skyblue")
        setWusprd("skyblue")
        setEusprd("skyblue")
        setWeuprd("skyblue")
        setEjpprd("skyblue")
        fetchApi(d, url, setEusstg, setWeustg, setEjpprd, setEusprd, setWeuprd, setWusprd, setEusstgCount, setWeustgCount, setEusprdCount, setWeuprdCount, setEjpprdCount, setWusprdCount)
    }, 400000)
}

